module.exports = __webpack_public_path__ + "img/5.9e0b33ff.jpg";